import TabsMui from '@mui/material/Tabs';
import styled from 'styled-components';

export const TabsContainer = styled(TabsMui)`
    &.MuiTabs-root {
        min-height: 26px;
    }

    .MuiTabs-list {
        justify-content: flex-start;
        flex-wrap: wrap;
        gap: 20px;
    }

    .MuiTab-root {
        ${(props) => props.theme.typography.textBold}
        color: ${(props) => props.theme.palette.textLight};
        min-height: auto;

        &.Mui-selected {
            color: ${(props) => props.theme.palette.primaryA1};
        }
    }

    .MuiTabs-indicator {
        background-color: ${(props) => props.theme.palette.primaryA1};
    }

    .MuiTab-iconWrapper {
        margin-right: 8px;
    }
`;
